export default {
  jp: {
    title: {
      list: 'アカウント一覧',
      add: 'アカウント追加',
      detail: 'アカウント詳細／変更',
      delete: 'アカウント削除'
    },
    error: {
      accountEntryId: {
        notExist: '既に審査が終わっているアカウントです。一覧に戻り、最新の情報を確認してください。',
        noAuthority: '権限のないアカウントです。'
      },
      accountEntryIds: {
        notExist: '既に審査が終わっているアカウントが含まれています。一覧に戻り、最新の情報を確認してください。',
        noAuthority: '権限のないアカウントが含まれています。'
      },
      accountId: {
        notExist: 'アクセスしようとしたアカウントは存在しないか削除されています。最新の情報を確認してください。',
        noAuthority: 'アカウントに対する操作権限がありません。',
        notExistsGroupAdmin: '他にグループ責任者が存在しないため、設定を変更をすることができません。他のアカウントをグループ責任者に変更のうえ、処理を実施するようお願いいたします。',
        notExistsAdmin: '他に管理者が存在しないため、設定を変更をすることができません。他のアカウントを管理者に変更のうえ、処理を実施するようお願いいたします。'
      },
      accountIds: {
        notExist: '既に削除済みのアカウントが含まれています。一覧に戻り、最新の情報を確認してください。'
      },
      mailAddress: {
        required: 'IDは入力必須項目です。',
        maxLength: 'IDは100文字以内で入力してください。',
        invalid: 'IDの書式に誤りがあります。',
        isDuplicated: '入力されたIDはすでに使用済みになります。別のIDを入力してください。'
      },
      name: {
        required: '氏名は入力必須項目です。',
        maxLength: '氏名は50文字以内で入力してください。'
      },
      groupLargeId: {
        required: '所属（大分類）は入力必須項目です。',
        invalid: '所属（大分類）の入力内容に不備があります。'
      },
      groupSmallId: {
        required: '所属（小分類）は入力必須項目です。',
        invalid: '所属（小分類）の入力内容に不備があります。'
      },
      companyId: {
        required: '##COMPANY_LABEL##は入力必須項目です。',
        invalid: '##COMPANY_LABEL##の入力内容に不備があります。'
      },
      companyName: {
        required: '##COMPANY_LABEL##名は入力必須項目です。',
        maxLength: '##COMPANY_LABEL##名は100文字以内で入力してください。'
      },
      companyNameKana: {
        required: '##COMPANY_LABEL##名（カナ）は入力必須項目です。',
        maxLength: '##COMPANY_LABEL##名（カナ）は100文字以内で入力してください。',
        invalid: '##COMPANY_LABEL##名（カナ）は全角カナ、・、－で入力してください。'
      },
      branchId: {
        required: '##BRANCH_LABEL##は入力必須項目です。',
        invalid: '##BRANCH_LABEL##の入力内容に不備があります。'
      },
      branchName: {
        required: '##BRANCH_LABEL##名は入力必須項目です。',
        maxLength: '##BRANCH_LABEL##名は100文字以内で入力してください。'
      },
      branchNameKana: {
        required: '##BRANCH_LABEL##名（カナ）は入力必須項目です。',
        maxLength: '##BRANCH_LABEL##名（カナ）は100文字以内で入力してください。',
        invalid: '##BRANCH_LABEL##名（カナ）は全角カナ、・、－で入力してください。'
      },
      postNo: {
        required: '郵便番号は入力必須項目です。',
        maxLength: '郵便番号は20文字以内で入力してください。'
      },
      prefCd: {
        required: '都道府県は入力必須項目です。',
        invalid: '都道府県の入力内容に不備があります。'
      },
      addr1: {
        required: '市区町村は入力必須項目です。',
        maxLength: '市区町村は100文字以内で入力してください。'
      },
      addr2: {
        required: '番地は入力必須項目です。',
        maxLength: '番地は100文字以内で入力してください。'
      },
      addr3: {
        maxLength: 'ビル名は100文字以内で入力してください。'
      },
      busho: {
        required: '部署は入力必須項目です。',
        maxLength: '部署は100文字以内で入力してください。'
      },
      telNo: {
        required: '電話番号は入力必須項目です。',
        maxLength: '電話番号は20文字以内で入力してください。'
      },
      remarks: {
        maxLength: '備考は20000文字以内で入力してください。'
      },
      services: {
        required: '利用希望サービスは入力必須項目です。',
        noAuthority: '権限のない利用希望サービスは選択できません。'
      },
      serviceApplication: {
        exitsUnderJudegeWait: '審査中の利用希望サービスは選択できません。',
        applicationTargetNotExist: '承認対象の申請が存在しません。一覧に戻り、最新の情報を確認してください。'
      },
      serviceApplications: {
        applicationTargetNotExist: '承認対象の申請が存在しません。一覧に戻り、最新の情報を確認してください。'
      },
      rejectMailList: {
        subject: {
          required: 'メール件名は必須項目です。',
          maxLength: 'メール件名は100文字以内で入力してください。'
        },
        body: {
          required: 'メール本文は必須項目です。',
          maxLength: 'メール本文は20000文字以内で入力してください。'
        }
      }
    },
    label: {
      mailAddress: 'ID',
      password: 'パスワード',
      name: '氏名',
      group: '所属',
      company: '会社',
      branch: '支社・支局または媒体',
      postNo: '郵便番号',
      prefCd: '都道府県',
      addr1: '市区町村',
      addr2: '番地',
      addr3: 'ビル名',
      busho: '部署',
      telNo: '電話番号',
      remarks: '備考',
      services: '利用希望',
      groupAdminFlg: '責任者設定',
      tempStopFlg: '一時停止設定',
      mailReceiveFlg: 'メール設定',
      adminFlg: '管理者設定'
    },
    ph: {
      mailAddress: 'メールアドレスを入力してください',
      name: '氏名を入力してください',
      groupSmall: '選択してください',
      companyId: '選択してください',
      companyName: '「その他」を選択した場合に##COMPANY_LABEL##名を入力してください',
      companyNameKana: '「その他」を選択した場合に##COMPANY_LABEL##名（カナ）を入力してください',
      branch: '##BRANCH_LABEL##がある場合は選択してください',
      branchName: '「その他」を選択した場合に##BRANCH_LABEL##名を入力してください',
      branchNameKana: '「その他」を選択した場合に##BRANCH_LABEL##名（カナ）を入力してください',
      postNo: '郵便番号を入力してください',
      prefCd: '選択してください',
      addr1: '市区町村を入力してください',
      addr2: '番地を入力してください',
      addr3: 'ビル名を入力してください',
      busho: '部署を入力してください',
      telNo: '電話番号を入力してください',
      remarks: '備考を入力してください',
      password: 'パスワードをリセットする',
      groupAdminFlg: 'グループ責任者に設定する',
      tempStopFlg: 'アカウントを一時的に利用停止に設定する',
      mailReceiveFlg: 'アカウント関連のメールを受信する',
      adminFlg: '管理者として登録する'
    },
    select: {
      other: 'その他'
    },
    button: {
      new: 'アカウント追加',
      search: '検索',
      reset: '選択行のパスワードをリセット',
      back: '戻る',
      add: '追加する',
      modify: '変更を保存する',
      delete: 'アカウントを削除する'
    },
    desc: {
      list: {
        text1: 'IDをクリックすることで詳細を表示できます。'
      },
      delete: {
        text1: 'アカウントを削除する場合は、以下のボタンをクリックしてください。'
      }
    }
  },
  en: {
  }

}
